// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IVp4HH {
  width: 100%;
  margin-bottom: 2rem;
}

.jA55iP {
  text-align: left;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  height: 25px;
}

@media (max-width: 768px) {
  .jA55iP {
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }

  .IVp4HH {
    margin-bottom: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProductBanners/ProductBanners.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".productBanners {\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.productBannersTitle {\n  text-align: left;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  height: 25px;\n}\n\n@media (max-width: 768px) {\n  .productBannersTitle {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .productBanners {\n    margin-bottom: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productBanners": `IVp4HH`,
	"productBannersTitle": `jA55iP`
};
module.exports = ___CSS_LOADER_EXPORT___;
